import React, { Component } from "react";
import { connect } from "react-redux";
import "./style/productDetail.scss";
import "./style/contribution.scss";
import ProductMiddleware from "../../store/prat_middleware/gt/productMiddleware";
import { openDB } from 'idb';

let isSaveDraft = false
let productData = [];
let contributionDataRes = []
class ContributionDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCustomer: [],
            incAwsValid: false,
            pawsValid: false
        };
    }
    firstTimeData(customer) {
        isSaveDraft = true
        const getData = async () => {
            if (!("indexedDB" in window)) {
                console.warn("IndexedDB not supported");
                return;
            }
            const dbName = "gt_form";
            const storeName = "product_store";
            const version = 1; //versions start at 1

            const db = await openDB(dbName, version, {

            });
            let result = await db
                .transaction(storeName)
                .objectStore(storeName)
                .get("contribution_detail");

            let productRes = await db
                .transaction(storeName)
                .objectStore(storeName)
                .get("product_detail");

                let customerChangedRes = await db
                    .transaction(storeName)
                    .objectStore(storeName)
                    .get("is_customer_changed");

            contributionDataRes = result ? result.value : []
            productData = productRes ? productRes.value : []

            productData = productData[0] ? productData[0] : productData
            customerChangedRes = customerChangedRes.value;

            console.log(contributionDataRes)
            
            if(customerChangedRes){
                if (productData && customer) {
    
                    let filteredCustomer = []
                    customer.forEach(item => {
                        if (productData.direct_customers.includes(item.guid)) {
                            filteredCustomer.push({
                                customer_name: item.Name,
                                customer_code: item.Code,
                                inc_aws: 0,
                                paws: 0
                            })
                        }
                    });
                    let incAwsValid = this.handleCheckValidity(filteredCustomer, 'inc_aws');
                    let pawsValid = this.handleCheckValidity(filteredCustomer, 'paws');
                    this.setState({
                        selectedCustomer: [...filteredCustomer],
                        incAwsValid,
                        pawsValid
                    })
                }
            }
            else{
                let incAwsValid = this.handleCheckValidity(contributionDataRes, 'inc_aws');
                let pawsValid = this.handleCheckValidity(contributionDataRes, 'paws');
                this.setState({
                    selectedCustomer: [...contributionDataRes],
                    incAwsValid,
                    pawsValid
                })
            }

        }

        getData();
        isSaveDraft = true
    }
    componentDidMount() {
        // this.props.get_productCustomer();
        this.firstTimeData(this.props.product_customer)

    }

    contributionData(data, flag, for_newPromotion) {
        const saveData = async (data, flag) => {
            if (!("indexedDB" in window)) {
                console.warn("IndexedDB not supported");
                return;
            }
            const dbName = "gt_form";
            const storeName = "product_store";
            const version = 1; //versions start at 1

            const db = await openDB(dbName, version, {
                upgrade(db, oldVersion, newVersion, transaction) {
                    const store = db.createObjectStore(storeName);      // eslint-disable-line
                }
            });
            const tx = await db.transaction(storeName, "readwrite");
            const store = await tx.objectStore(storeName);
            let draft = undefined;
            if (!for_newPromotion) {
                const value = await store.put({ "key": "contribution_123", "value": data }, "contribution_detail");      // eslint-disable-line
                const isSave = await store.put({ "key": "draft_123", "value": flag }, "is_draft_saved")         // eslint-disable-line
                await store.put({ "key": "customer_123", "value": false }, "is_customer_changed");

                await tx.dones;
                let resp; let txs; let obj;
                resp = await db
                txs = await resp.transaction(storeName)
                obj = await txs.objectStore(storeName)
                let contributionDataResult = await obj.get('contribution_detail');
                draft = await obj.get('is_draft_saved');
                contributionDataRes = contributionDataResult ? contributionDataResult.value : []
                draft = draft ? draft.value : void 0
            } else {
                const isNewPromotion = await store.put({ "key": "is_newPromotion", "value": for_newPromotion },     // eslint-disable-line
                    "is_newPromotion")

            }
            this.props.call_back(this.props.draft_state === true ? true : isSaveDraft === true ? false : draft)
        }
        if (isSaveDraft === false) {
            saveData(data, flag)
        }
        else {
            isSaveDraft = false
        }
    }


    getChannelData() {
        const getData = async () => {
            if (!("indexedDB" in window)) {
                console.warn("IndexedDB not supported");
                return;
            }
            const dbName = "gt_form";
            const storeName = "product_store";
            const version = 1; //versions start at 1

            const db = await openDB(dbName, version, {

            });
            let result = await db
                .transaction(storeName)
                .objectStore(storeName)
                .get("contribution_detail");

            contributionDataRes = result ? result.value : []
            this.setState({
                selectedCustomer: [...contributionDataRes]
            })

        }

        getData();
    };

    handleCheckValidity = (arr, key) => {
        let total = 0;
        arr.forEach(item => {
            if(parseInt(item[key]) < 100 && arr?.length > 1){
                total = total + parseInt(item[key]);
            }
            else if(arr?.length === 1){
                total = total + parseInt(item[key]);
            }
        })
        console.log(total)
        if (parseInt(total) === 100) {
            return false;
        }
        else {
            return true;
        }
    }

    handleIncAws = (ind, val) => {
        let customers = [...this.state.selectedCustomer];
        customers[ind].inc_aws = val;
        let isValid = this.handleCheckValidity(customers, 'inc_aws');
        this.setState({
            selectedCustomer: customers,
            incAwsValid: isValid
        })
    };

    handlePaws = (ind, val) => {
        let customers = [...this.state.selectedCustomer];
        customers[ind].paws = val;
        let isValid = this.handleCheckValidity(customers, 'paws');
        this.setState({
            selectedCustomer: customers,
            pawsValid: isValid
        })
    };

    componentDidUpdate(prevProps, PrevState) {
        const {
            selectedCustomer
        } = this.state;
        isSaveDraft = false
        if ((this.state !== PrevState)) {
            if (isSaveDraft === false) {
                let statedata = [...selectedCustomer];

                this.contributionData(statedata, true)
            }
            else {
                isSaveDraft = false
            }
        }

        //    if((prevProps.product_customer!==this.props.product_customer)){
        //    this.firstTimeData(this.props.product_customer)
        //  }
    }

    render() {
        console.log(this.state.selectedCustomer)
        return (
            <>
                <div  >
                    <div className="product_detail">
                        <p>Contribution Detail</p>
                    </div>

                    <div className='contribution-table-container'>
                        <table className='contribution-table'>
                            <thead>
                                <tr style={{ backgroundColor: '#0353a4' }}>
                                    <th className='contri-cell cell-clr-white'>Customer Names</th>
                                    <th style={{ textAlign: 'center' }} className='contri-cell cell-clr-white'>Incremental AWS</th>
                                    <th style={{ textAlign: 'center' }} className='contri-cell cell-clr-white'>PAWS</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.selectedCustomer &&
                                    this.state.selectedCustomer.map((item, ind) => (
                                        <tr key={ind}>
                                            <td className='contri-cell contri-cell-border'>{item.customer_name}</td>
                                            <td className='contri-cell contri-cell-border'><input className='cell-input' value={item.inc_aws} type="text" onChange={(e) => this.handleIncAws(ind, e.target.value)} /></td>
                                            <td className='contri-cell contri-cell-border'><input className='cell-input' value={item.paws} type="text" onChange={(e) => this.handlePaws(ind, e.target.value)} /></td>
                                        </tr>
                                    ))
                                }
                                <tr>
                                    <td className='contri-cell'></td>
                                    <td className='contri-cell'>
                                        {this.state.incAwsValid &&
                                            <>
                                                <img style={{ width: '14px', marginRight: '6px' }} src={require('../../assets/images/round-warning.svg')} alt="" />
                                                <span style={{ color: '#ce0000' }} >Overall contribution should be 100%</span>
                                            </>
                                        }
                                    </td>
                                    <td className='contri-cell'>
                                        {this.state.pawsValid &&
                                            <>
                                                <img style={{ width: '14px', marginRight: '6px' }} src={require('../../assets/images/round-warning.svg')} alt="" />
                                                <span style={{ color: '#ce0000' }} >Overall contribution should be 100%</span>
                                            </>
                                        }
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </>
        );
    }
}


const mapStateToProps = state => {
    return {
        draftData: state.CreatePromotionReducer.draftData,
        product_customer: state.ProductReducer.productCustomer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        get_productCustomer: () => {
            return dispatch(ProductMiddleware.get_customers());
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ContributionDetail);
